var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BContainer',{staticClass:"px-0",attrs:{"fluid":""}},[(_vm.busy)?_c('BRow',{staticClass:"mb-3"},[_c('BCol',{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center py-5"},[_c('BIcon',{attrs:{"icon":"stopwatch","font-scale":"5","animation":"cylon"}}),_c('p',{staticClass:"h3 py-2"},[_c('strong',[_vm._v("Loading . . .")])])],1)])],1):(Number(_vm.tasks.totalRows) <= 0 && !_vm.busy)?_c('BRow',[_c('BCol',{staticClass:"text-center py-5",attrs:{"cols":"12"}},[_c('BIcon',{attrs:{"icon":"calendar","font-scale":"5"}}),_c('p',{staticClass:"h3 py-2"},[_c('strong',[_vm._v("No officer tasks found")])])],1)],1):_c('BRow',{staticClass:"gap-y-6"},_vm._l((_vm.tasks.rows),function(activity){return _c('BCol',{key:activity?.id,attrs:{"cols":"12","md":"6"}},[_c('Task',{attrs:{"activity":{
          activity_name: activity.activity_name,
          total_buyers: activity.customers_bought_count
        },"current-progress":{
          event: activity.events_count,
          customer: activity.customers_attended_count,
          hectare: activity.total_actual_hectares,
          cost: activity.total_actual_costs,
          sales: activity.total_actual_sales
        },"total-progress":{
          event: activity.event_plan,
          customer: activity.total_customer_plan,
          hectare: activity.total_hectare_plan,
          cost: activity.total_budget_plan,
          sales: activity.total_sales_plan
        }}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }